// Config for the market-focused blog articles rendered in the premium country-page theme.
// Each entry maps a blog slug to its market so MarketGuidePage can render the right
// breadcrumb, hero image and back-links without a bespoke page per article.

const UK_IMAGE = '/images/uk-london.jpg';
const US_IMAGE = 'https://images.unsplash.com/photo-1514565131-fce0801e5785?crop=entropy&cs=srgb&fm=jpg&q=85&w=2000';
const UAE_IMAGE = 'https://images.unsplash.com/photo-1634007626524-f47fa37810a7?crop=entropy&cs=srgb&fm=jpg&q=85&w=2000';
const SG_IMAGE = 'https://images.unsplash.com/photo-1727859146476-c60c7f8f9764?crop=entropy&cs=srgb&fm=jpg&q=85&w=2000';
const CA_IMAGE = 'https://images.unsplash.com/photo-1486325212027-8081e485255e?crop=entropy&cs=srgb&fm=jpg&q=85&w=2000';

const MARKETS = {
  us: { label: 'United States', path: '/usa', image: US_IMAGE, alt: 'United States skyline at dusk' },
  uk: { label: 'United Kingdom', path: '/country/uk', image: UK_IMAGE, alt: 'London skyline above the River Thames' },
  uae: { label: 'United Arab Emirates', path: '/country/uae', image: UAE_IMAGE, alt: 'Dubai skyline at dusk' },
  singapore: { label: 'Singapore', path: '/country/singapore', image: SG_IMAGE, alt: 'Marina Bay Singapore at dusk' },
  canada: { label: 'Canada', path: '/country/canada', image: CA_IMAGE, alt: 'Toronto skyline at dusk' },
};

// slug -> market key
export const MARKET_GUIDE_SLUGS = {
  'register-us-company-from-india': 'us',
  'register-us-company-from-uk': 'us',
  'choosing-a-us-state-to-form-an-llc': 'us',
  'register-uk-company-from-india': 'uk',
  'register-uk-company-from-usa': 'uk',
  'register-uae-company-from-india': 'uae',
  'uae-mainland-vs-free-zone': 'uae',
  'business-setup-in-dubai': 'uae',
  'register-singapore-company-from-india': 'singapore',
  'singapore-vs-hong-kong-incorporation': 'singapore',
  'register-canada-company-from-india': 'canada',
  'federal-vs-provincial-incorporation-canada': 'canada',
  'canada-corporate-tax-rates': 'canada',
  'canada-gst-hst-registration-foreign-companies': 'canada',
  'canada-annual-compliance': 'canada',
  'singapore-gst-filing-foreign-companies': 'singapore',
  'us-sales-tax-economic-nexus': 'us',
  'uk-vat-making-tax-digital': 'uk',
  'transfer-pricing-arms-length-principle': 'us',
  'permanent-establishment-risk': 'us',
  'register-us-company-from-canada': 'us',
  'register-us-company-from-germany': 'us',
  'register-us-company-from-australia': 'us',
  'register-us-company-from-nigeria': 'us',
  'register-uk-company-from-germany': 'uk',
  'register-uk-company-from-australia': 'uk',
  'register-uae-company-from-uk': 'uae',
  'register-uae-company-from-usa': 'uae',
  'register-singapore-company-from-australia': 'singapore',
  'register-canada-company-from-uk': 'canada',
  'transfer-pricing-us-to-uk': 'us',
  'transfer-pricing-us-to-india': 'us',
  'transfer-pricing-uk-to-india': 'uk',
  'transfer-pricing-singapore-to-us': 'singapore',
};

export const getMarketForSlug = (slug) => MARKETS[MARKET_GUIDE_SLUGS[slug]] || null;

export const SITE_ORIGIN = process.env.REACT_APP_PUBLIC_SITE_URL;
